import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PILLARS } from "../data/plans";

const accentMap = {
  signal: "bg-signal/10 text-signal",
  gold: "bg-gold/10 text-gold",
  health: "bg-health/10 text-health",
};

export function ProductPillars() {
  const { t } = useTranslation();
  return (
    <section className="py-24 md:py-32 border-t border-white/5" data-testid="product-pillars">
      <div className="container-x">
        <Reveal>
          <Overline>{t("pillars.overline")}</Overline>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl">{t("pillars.title")}</h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Sparkles;
            const Wrapper = p.to ? Link : "div";
            const wrapperProps = p.to ? { to: p.to } : {};
            return (
              <Reveal key={p.id} delay={i * 0.05}>
                <Wrapper {...wrapperProps} className="group block surface p-8 h-full surface-hover" data-testid={`pillar-${p.id}`}>
                  <div className="flex items-start justify-between">
                    <div className={`w-12 h-12 rounded-xl grid place-items-center ${accentMap[p.accent]}`}>
                      <Icon size={22} />
                    </div>
                    {p.to && <ArrowUpRight size={18} className="text-white/30 group-hover:text-white transition-colors rtl:-scale-x-100" />}
                  </div>
                  <h3 className="mt-6 font-display font-semibold text-lg text-white">{t(`data.pillars.${p.id}.title`)}</h3>
                  <p className="mt-3 text-sm text-white/55 leading-relaxed">{t(`data.pillars.${p.id}.desc`)}</p>
                </Wrapper>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="mt-8 text-xs text-white/40 max-w-2xl leading-relaxed">{t("pillars.complianceNote")}</p>
        </Reveal>
      </div>
    </section>
  );
}

export default ProductPillars;
